import { PreferencesPage } from '@/pages/preferences'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/preferences/')({
	component: PreferencesPage,
})
